export default "__VITE_ASSET__dcabbede__"